export const CLEAR_MARK_STYLE = {left: '', right: '', transform: ''};
